/**
 * Called when we handle redirect called by ajax request
 * @param url the new window location
 * @param redirectOptions additional option for behavior of redirect
 */
export function redirectToLocation(url, redirectOptions) {
    if (!url) {
        throw createError('Empty url parameter.')
    }

    switch (redirectOptions) {
        case 'sameWindow':
            openInSameWindow(url)

            // Reject the promise in either case, so that subsequent resolution handlers get not called, even
            // when the browser navigates to different URL.
            throw createError('When the browser goes to another url, reject the promise.')
        case 'newWindow':
        default:
            return openInNewTab(url)
    }
}

/**
 * Opens the linked document in the same window/tab
 * @param url location
 */
function openInSameWindow(url) {
    window.location.href = url
}

/**
 * Opens the linked document in a new window or tab
 * @param url location
 */
function openInNewTab(url) {
    return window.open(url, '_blank')
}

/**
 * Called by checkStatus to create error object upon action failure
 * @return an error object containing error status code, status text and error reasons as promise resolving to json
 */
function createError(message) {
    const error = new Error(message)
    error.status = 410
    error.reasons = Promise.resolve()
    return error
}
